import { createContext, useCallback, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SearchMovimientosRequest } from '../models/SearchMovimientosRequest';

export interface ITransactionList {
  searchParams: SearchMovimientosRequest | null;
  searchTransactions: (request: SearchMovimientosRequest) => void;
  reloadToken: number;
  reloadTransactionListAndFilters: () => void;
}

export const TransactionListContext = createContext<ITransactionList>({
  reloadToken: null,
  reloadTransactionListAndFilters: () => {},
  searchParams: null,
  searchTransactions: () => {},
});

export const TransactionListProvider = ({ children }) => {
  const [searchParamsUrl, setSearchParamsUrl] = useSearchParams();
  const [reloadToken, setReloadToken] = useState(0);

  const searchParams: SearchMovimientosRequest = useMemo(() => {
    const mes = searchParamsUrl.get('mes');
    const anio = searchParamsUrl.get('anio');
    const idTarjeta = searchParamsUrl.get('idTarjeta');
    const numeroCuenta = searchParamsUrl.get('numeroCuenta');
    return {
      mes: mes ? Number(mes) : null,
      anio: anio ? Number(anio) : null,
      buscarPor: searchParamsUrl.get('buscarPor') || ('CUENTA' as any),
      numeroCuenta: numeroCuenta ? Number(numeroCuenta) : null,
      idTarjeta: idTarjeta ? Number(idTarjeta) : null,
      codigoRubro: searchParamsUrl.get('codigoRubro'),
      detalleTipoOperacion: searchParamsUrl.get('detalleTipoOperacion'),
      nombreEstablecimiento: searchParamsUrl.get('nombreEstablecimiento'),
    };
  }, [searchParamsUrl]);

  const searchTransactions = useCallback(
    (request: SearchMovimientosRequest) => {
      const rawData = {
        mes: request.mes,
        anio: request.anio,
        buscarPor: request.buscarPor,
        numeroCuenta: request.numeroCuenta,
        idTarjeta: request.idTarjeta,
        codigoRubro: request.codigoRubro,
        detalleTipoOperacion: request.detalleTipoOperacion,
        nombreEstablecimiento: request.nombreEstablecimiento,
      };

      // Filtramos valores nulos
      const cleanEntries = Object.entries(rawData)
        .filter(([_, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => [key, String(value)]);
      setSearchParamsUrl(new URLSearchParams(cleanEntries));
      setReloadToken((v) => v + 1);
    },
    [setSearchParamsUrl],
  );

  const reloadTransactionListAndFilters = useCallback(() => {
    setReloadToken((v) => v + 1);
  }, []);

  return (
    <TransactionListContext.Provider
      value={{
        searchParams,
        searchTransactions,
        reloadToken,
        reloadTransactionListAndFilters,
      }}
    >
      {children}
    </TransactionListContext.Provider>
  );
};
